// useClaimSettings.ts
import { useQuery } from "@tanstack/react-query";
import { get } from "@/common/services/httpClient";
import { API_ENDPOINTS } from "../../features/claim/api/apiEndpoints";

export interface ClaimSettings {
    undoPaidTimeLimitMinutes?: number; // optional is fine
}

export const useClaimSettings = () => {
    return useQuery<ClaimSettings>({
        queryKey: ["claimSettings"],
        queryFn: async () => {
            const response = await get<ClaimSettings>(API_ENDPOINTS.CLAIM.GET_SETTINGS);
            return response; // make sure your `get` returns the actual data, not wrapped object
        },
        staleTime: Infinity,
        gcTime: Infinity,
    });
};
